import { useEffect } from "react";
import { usePage } from "@inertiajs/react";
import { toast } from "sonner";

import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";

export default function RootLayout({ children }) {
  const { flash } = usePage();

  useEffect(() => {
    if (flash.alert) toast.error(flash.alert);
    if (flash.notice) toast.info(flash.notice);
  }, [flash]);

  return (
    <div>
      <TooltipProvider>
        {children}
      </TooltipProvider>

      <Toaster />
    </div>
  );
};
